export default "__VITE_ASSET__BrFOAehr__"